import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  Grid,
  useTheme,
} from "@mui/material";
import {
  addActiveRequests,
  updateLoading,
  updateLoadingMsg,
} from "../../../Redux/Reducers/uiSlice";
import { useDispatch } from "react-redux";
import { sendWebSocketMessage } from "../../../hooks/useWebSocket";
const DeletePopUp = (props) => {
  const theme = useTheme();
  const {
    title,
    openDeletePopup,
    setDeleteOpenPopup,
    recordForDelete,
    deleteObj,
    item,
  } = props;
  const dispatch = useDispatch();
  const message = item?.charAt(0).toUpperCase() + item?.slice(1);
  const deleteItem = () => {
    if (deleteObj == "delete_custodian") {
      sendWebSocketMessage(
        `{"action":"delete_custodian", "data":{"custodian":${JSON.stringify(
          recordForDelete
        )}}}`
      );
      dispatch(addActiveRequests("delete_custodian"));
    } else if (deleteObj == "delete_broker") {  
      sendWebSocketMessage(
        `{"action":"delete_broker", "data":{"broker":${JSON.stringify(
          recordForDelete
        )}}}`
      );
      dispatch(addActiveRequests("delete_broker"));
    } else if (deleteObj == "delete_fund") {
      sendWebSocketMessage(
        `{"action":"delete_fund", "data":{"fund":${JSON.stringify(
          recordForDelete
        )}}}`
      );
    } else if (deleteObj == "delete_security_map") {
      // sendWebSocketMessage(
      //   `{"action":"delete_fund", "data":{"fund":${JSON.stringify(
      //     recordForDelete
      //   )}}}`
      // );
    }
    // else if (deleteObj == "delete_user") {
    //   sendWebSocketMessage(
    //     `{"action":"delete_user", "data":{"user":${JSON.stringify(
    //       recordForDelete
    //     )}}}`
    //   );
    // }
    else if (deleteObj == "delete_strategy") {
      sendWebSocketMessage(
        `{"action":"delete_strategy", "data":{"strategyId":${JSON.stringify(
          recordForDelete?.strategyId
        )}}}`
      );
      dispatch(addActiveRequests("delete_strategy"));
    } else if (deleteObj == "delete_blacklistedTicker") {
      // sendWebSocketMessage(
      //   `{"action":"delete_blacklistedTicker", "data":{"strategy":${JSON.stringify(
      //     recordForDelete
      //   )}}}`
      // );
    }
  
    dispatch(updateLoading(true));
    dispatch(updateLoadingMsg(`Deleting ${message}...`));
    setDeleteOpenPopup(false);
  };
  const displayValue =
    recordForDelete?.name ||
    recordForDelete?.ticker_symbol ||
    recordForDelete?.ticker ||
    "Unknown";
  return (
    <Dialog open={openDeletePopup} sx={{ width: "100%", height: "100%" }}>
      <DialogTitle>
        <Typography
          variant="h6"
          component="div"
          align="center"
          style={{ flexGrow: 1, fontSize: "20px" }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body" component="div" style={{ flexGrow: 1 }}>
          {`Are you sure you want to delete ${displayValue} ?`}
        </Typography>
        <Grid
          item
          xs={12}
          margin="20px 1px 20px 1px "
          display="flex"
          justifyContent="center"
          columnGap={1}
        >
          <Button
            variant="contained"
            sx={{
              width: "40%",
              background: theme.palette.red[200],
              "&:hover": { background: theme.palette.red[300] },
            }}
            onClick={() => {
              deleteItem();
            }}
          >
            DELETE
          </Button>
          <Button
            variant="contained"
            sx={{
              width: "40%",
              background: "#B2BEB5",
              color: "#000",
              "&:hover": { background: "#808080" },
            }}
            onClick={() => {
              setDeleteOpenPopup(false);
            }}
          >
            CANCEL
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default DeletePopUp;
